module.exports = __webpack_public_path__ + "static/fonts/CoTextCorp-Regular.75f595b.ttf";